/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
// custom SVG Icon import
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
// custom component import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { tableGridHight350 } from '../../../../SharedModules/CommonConstants/commonConstants';
// custom function import
import {
  closeTab,
  handleRefreshCell,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import {
  checkGridTableHead,
  TableHeaderForInvoiceGrid,
  TableHeaderForQuarter,
} from './gridComponents/tableHead';
import {
  setSuspendedCheckTab,
  getSuspendedCheckLogGrid,
  getUnallocatedBalance,
  dispatchUnallocatedBalance,
  getCreditBalConfirmation,
  handleErrorMessagesInRedux,
  dispatchInvoiceGridList,
  dispatchCreditBalConfirmation,
  getInvoiceGridData,
  dispatchReconciliationGridList,
  getReconciliationGridData,
  dispatchGetSuspendedCheckLogGrid,
  postSaveOrUpdate,
} from '../store/Actions';
import {
  isReadOnly as isRead,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

function SuspendedCheckComponent(props) {
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly;
  if (loginState) {
    isReadOnly = isRead(props.location.pathname, loginState).readOnly;
  }
  const dispatch = useDispatch();
  const history = useHistory();
  // dispatch function
  const addEditSuspendedCheckTab = (data) => {
    return dispatch(setSuspendedCheckTab(data));
  };
  // use Selector function
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.SuspendedCheckReducer?.errorMessagesInRedux;
  });
  const suspendedCheckTabData = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.suspendedCheckTabObj;
  });
  const suspendedCheckLogResponse = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.suspendedCheckLogGridList?.sort(
      (a, b) => a.checkLogNum - b.checkLogNum
    );
  });
  const suspendedChecksMfgResponse = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.invoiceGridList?.sort(
      (a, b) => a.mfgId - b.mfgId
    );
  });
  const suspendedChecksInvoiceResponseVO = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.reconciliationGridList?.sort(
      (a, b) => a.invRecQtr - b.invRecQtr
    );
  });
  const creditBalanceCount = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.creditBalanceCount;
  });
  const unallocatedBalance = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.unallocatedBalance;
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.SuspendedCheckReducer?.saveOrUpdateMessage;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  // variable deceleration
  const gridRef = React.useRef();
  const gridRef1 = React.useRef();
  const [flag,setFlag] = React.useState([])
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [overpaymentConfirmPopup, setOverpaymentConfirmPopup] = useState(false);
  const [creditBalanceConfirmPopup, setCreditBalanceConfirmPopup] =
    useState(false);
  const [warningAlert, setWarningAlert] = useState(false);
  const [fullScreenViewForFirstGrid, setFullScreenViewForFirstGrid] =
    useState(false);
  const [fullScreenViewForSecondGrid, setFullScreenViewForSecondGrid] =
    useState(false);
  const [fullScreenViewForThirdGrid, setFullScreenViewForThirdGrid] =
    useState(false);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState('Yes');
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [warningMessage, setWaringMessage] = useState('');
  const [warningTitle, setWaringTitle] = useState('');
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [gridParams, setGridParams] = useState(null);
  const [gridParamsForInvGrid, setGridParamsForInvGrid] = useState(null);
  const [linkTableName, setLinkTableName] = useState('CHECK_LOG');
  const [keyValue, setKeyValue] = useState([]);
  const [rowGridPrimaryKey, setRowGridPrimaryKey] = useState('');
  const [suspendedCheckGridData, setSuspendedCheckGridData] = useState([]);
  const [suspendedCheckInvGirdData, setSuspendedCheckInvGirdData] = useState(
    []
  );
  const [successMessages, setSuccessMessage] = useState([]);
  const [permanentDeleteCheckList, setPermanentDeleteCheckList] = useState([]);
  const [flagCheck, setFlagCheck] = React.useState(false)
  const [flagcCheckThird, setFlagCheckThird] = React.useState(false)
  const [mfgSelect, setMfgSelected] = React.useState({});

  // handling onPage load call service
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(dispatchCreditBalConfirmation({}));
    dispatch(dispatchUnallocatedBalance({}));
    setWarningAlert(false);
  }, []);

  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'checkLogNum', sort: 'asc' }],
        });
      }
    }
  };
  // click on filter icon after call
  const handleClearFilterForInvGrid = () => {
    if (gridRef1 !== null) {
      gridRef1.current.clearFilters();
      if (
        gridParamsForInvGrid?.columnApi &&
        gridParamsForInvGrid?.columnApi !== null
      ) {
        gridParamsForInvGrid.columnApi.applyColumnState({
          state: [{ colId: 'mfgId', sort: 'asc' }],
        });
      }
    }
  };
  // fetch Invoice Grid table data
  const fetchInvoiceGridList = (row) => {
    if (
      suspendedChecksMfgResponse?.length === 0 ||
      suspendedChecksMfgResponse?.filter((x) => {
        return x.checkLogNum !== row?.checkLogNum;
      }).length > 0
    ) {
      dispatch(dispatchInvoiceGridList([]));
      setSuspendedCheckInvGirdData([]);
      dispatch(dispatchReconciliationGridList([]));
      addEditSuspendedCheckTab({
        ...suspendedCheckTabData,
        invGridSelectRowRedux: undefined,
      });
      handleClearFilterForInvGrid();
      if (row?.checkLogNum) {
        dispatch(getInvoiceGridData({ checkLogNum: row?.checkLogNum }));
      }
    }
  };
  // fetch Invoice Grid table data
  const fetchReconciliationGridList = (row) => {
    if (
      suspendedCheckInvGirdData?.length === 0 ||
      suspendedCheckInvGirdData?.filter((x) => {
        return (
          x.invoiceNum !== row?.invoiceNum &&
          x.invRecSeqNum !== row?.invRecSeqNum
        );
      }).length > 0
    ) {
      dispatch(dispatchReconciliationGridList([]));
      if (row?.invoiceNum && row?.invRecSeqNum) {
        dispatch(
          getReconciliationGridData({
            invoiceNum: row?.invoiceNum,
            invRecSeqNum: row?.invRecSeqNum,
          })
        );
      }
    }
  };
  // removing check Suspension click option
  const handleRemoveCheckSuspension = (row, flag, type) => {
    const deleteRow = row;
    setDeletePopup(false);
    setOverpaymentConfirmPopup(false);
    setCreditBalanceConfirmPopup(false);
    setDisabledSaveCancelBtn('No');
    setSuccessMessage([]);
    const newObj = [...suspendedCheckLogResponse];
    if (newObj && newObj?.length > 0) {
      const key = newObj.findIndex((item) => {
        return item.checkLogNum === row?.checkLogNum;
      });
      newObj.splice(key, 1);
      setSuspendedCheckGridData(newObj);
      const temObj = [...permanentDeleteCheckList];
      deleteRow.suspendedDtFlag = flag;
      if (type) deleteRow.balanceTypeCd = type;
      deleteRow.mfgId = suspendedCheckTabData?.invGridSelectRowRedux?.mfgId;
      deleteRow.rebateProgramCd =
        suspendedCheckTabData?.invGridSelectRowRedux?.rebateProgramCd;
      temObj.push(deleteRow);
      setPermanentDeleteCheckList(temObj);
      dispatch(dispatchGetSuspendedCheckLogGrid(newObj));
      if (newObj?.length > 0) {
        addEditSuspendedCheckTab({
          ...suspendedCheckTabData,
          suspendedCheck: undefined,
          rowSelectedInRedux: newObj[0],
          disabledSaveCancelBtn: 'No',
          successMessages: [],
          permanentDeleteCheckList: temObj,
        });
        setFlag(newObj)
        // setTimeout(() => {
          
        // }, 100);
      } else {
        addEditSuspendedCheckTab({
          ...suspendedCheckTabData,
          disabledSaveCancelBtn: 'No',
          successMessages: [],
          permanentDeleteCheckList: temObj,
        });
        setSuspendedCheckInvGirdData([]);
        dispatch(dispatchReconciliationGridList([]));
      }
    }
  };
  // click on Declare Overpayment Confirmation popup after call API service
  const handleUnallocatedBalance = (suspendedCheckTabObj) => {
    setOverpaymentConfirmPopup(false);
    setCreditBalanceConfirmPopup(false);
    const selectedRow =
      suspendedCheckTabObj.defaultSelectedRow ||
      suspendedCheckTabObj?.invGridSelectRowRedux;
    dispatch(
      getUnallocatedBalance({
        allocatedCheckLogNum:
          suspendedCheckTabObj.rowSelectedInRedux?.checkLogNum,
        mfgId: selectedRow?.mfgId,
        rebateProgramCd: selectedRow?.rebateProgramCd,
      })
    );
  };
  // handling onPage load set check log grid data
  React.useEffect(() => {
    if (suspendedCheckLogResponse?.length > 0) {
      fetchInvoiceGridList(
        suspendedCheckTabData?.rowSelectedInRedux
          ? suspendedCheckTabData?.rowSelectedInRedux
          : suspendedCheckLogResponse[0]
      );
      setSuspendedCheckGridData(suspendedCheckLogResponse);
      if (suspendedCheckTabData?.rowSelectedInRedux)
        setSuspendedCheckGridData(suspendedCheckLogResponse);
      addEditSuspendedCheckTab({
        ...suspendedCheckTabData,
        rowSelectedInRedux: suspendedCheckTabData?.rowSelectedInRedux
          ? suspendedCheckTabData?.rowSelectedInRedux
          : suspendedCheckLogResponse[0],
      });
      setFlagCheck(true)
      // setTimeout(() => {
      //   console.log(suspendedCheckTabData?.rowSelectedInRedux,'suspendedCheckTabData?.rowSelectedInRedux')
      //   if (gridParams !== null && !suspendedCheckTabData?.rowSelectedInRedux) {
      //     gridParams.api.forEachNode((node) =>
      //       node.rowIndex ? 0 : node.setSelected(true)
      //     );
      //     // eslint-disable-next-line no-unused-expressions
      //     gridParams?.api?.setFilterModel(null);
      //   }
      // }, 100);
    } else {
      setSuspendedCheckGridData([]);
    }
  }, [suspendedCheckLogResponse]);

  React.useEffect(()=>{
    if(flagCheck&&gridParams !== null&&!suspendedCheckTabData?.rowSelectedInRedux){
      gridParams.api.forEachNode((node) =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.setFilterModel(null);
      setFlagCheck(false)
    }
  },[flagCheck,suspendedCheckTabData])

  React.useEffect(()=>{
    if (gridParams !== null&&flag?.length > 0) {
      fetchInvoiceGridList(flag[0]);
      gridParams.api.forEachNode((node) =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.setFilterModel(null);
      setFlag([])
    }
  },[flag])

  // handling onPage load set check log grid data
  React.useEffect(() => {
    if (suspendedChecksMfgResponse?.length > 0) {
      let mfgSelected =
        suspendedCheckTabData?.invGridSelectRowRedux &&
        suspendedCheckTabData?.rowSelectedInRedux?.checkLogNum ===
          suspendedCheckTabData?.invGridSelectRowRedux?.checkLogNum
          ? suspendedCheckTabData?.invGridSelectRowRedux
          : suspendedChecksMfgResponse[0];
      fetchReconciliationGridList(mfgSelected);
      setSuspendedCheckInvGirdData(suspendedChecksMfgResponse);
      if (mfgSelected) setSuspendedCheckInvGirdData(suspendedChecksMfgResponse);
      addEditSuspendedCheckTab({
        ...suspendedCheckTabData,
        invGridSelectRowRedux: mfgSelected,
      });
      setMfgSelected(mfgSelected)
      setFlagCheckThird(true)
    } else {
      setSuspendedCheckInvGirdData([]);
      dispatch(dispatchReconciliationGridList([]));
    }
  }, [suspendedChecksMfgResponse]);

  React.useEffect(()=>{
    if (gridParamsForInvGrid !== null && flagcCheckThird) {
      if (suspendedCheckTabData?.invGridSelectRowRedux) {
        gridParamsForInvGrid.api.forEachNode(
          (node) =>
            node?.data?.index ===
              suspendedChecksMfgResponse?.filter((x) => {
                const chkInd =
                  suspendedCheckTabData?.invGridSelectRowRedux
                    ?.checkLogNum === mfgSelect?.checkLogNum
                    ? suspendedCheckTabData?.invGridSelectRowRedux?.index
                    : mfgSelect?.index;
                return x.index === chkInd;
              })[0]?.index && node?.setSelected(true)
        );
      } else if (gridParamsForInvGrid !== null) {
        gridParamsForInvGrid.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      }
      // eslint-disable-next-line no-unused-expressions
      gridParamsForInvGrid?.api?.setFilterModel(null);
      setFlagCheckThird(false)
      setMfgSelected({})
    }
  },[flagcCheckThird,mfgSelect])
  // after come Credit balance API response call
  React.useEffect(() => {
    if (creditBalanceCount?.message === 'Success') {
      const checkAmt = parseFloat(
        suspendedCheckTabData?.rowSelectedInRedux?.checkAmt
          ?.toString()
          .split('$')[1]
          .trim()
      );
      if (creditBalanceCount?.count > 0 || checkAmt === 0) {
        dispatch(dispatchUnallocatedBalance({}));
        handleUnallocatedBalance(suspendedCheckTabData);
        addEditSuspendedCheckTab({
          ...suspendedCheckTabData,
          clickActionName: 'creditBalance',
        });
      } else {
        setWarningAlert(true);
        setWaringMessage(constantMessageData.WARNING_MSG_FOR_CREDIT_BALANCE);
        setWaringTitle('Display Suspended Checks');
      }
      dispatch(dispatchCreditBalConfirmation({}));
      setSuccessMessage([]);
    }
  }, [creditBalanceCount]);
  // after come over payments  API response call
  React.useEffect(() => {
    if (unallocatedBalance?.message === 'Success') {
      if (suspendedCheckTabData?.clickActionName === 'overPayment') {
        setOverpaymentConfirmPopup(true);
      }
      if (suspendedCheckTabData?.clickActionName === 'creditBalance') {
        setCreditBalanceConfirmPopup(true);
      }
      dispatch(dispatchUnallocatedBalance({}));
      setSuccessMessage([]);
    }
  }, [unallocatedBalance]);
  // handing refresh functionality
  React.useEffect(() => {
    if (Object.keys(suspendedCheckTabData)?.length === 0) {
      dispatch(getSuspendedCheckLogGrid({}));
    } else {
      const tempObj = suspendedCheckTabData;
      if (tempObj?.fullScreenViewForFirstGrid)
        setFullScreenViewForFirstGrid(tempObj.fullScreenViewForFirstGrid);
      if (tempObj?.fullScreenViewForSecondGrid)
        setFullScreenViewForSecondGrid(tempObj.fullScreenViewForSecondGrid);
      if (tempObj?.fullScreenViewForThirdGrid)
        setFullScreenViewForThirdGrid(tempObj.fullScreenViewForThirdGrid);
      if (tempObj?.disabledSaveCancelBtn)
        setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj?.permanentDeleteCheckList)
        setPermanentDeleteCheckList(tempObj.permanentDeleteCheckList);
      if (tempObj?.successMessages) setSuccessMessage(tempObj.successMessages);
      if (tempObj?.showComments) setShowComments(tempObj.showComments);
      if (tempObj?.linkTableName) setLinkTableName(tempObj.linkTableName);
    }
  }, [suspendedCheckTabData]);
  // handing by default first row selection function
  const onGridReady = (params) => {
    setGridParams(params);
    if (suspendedCheckTabData?.rowSelectedInRedux) {
      params.api.forEachNode(
        (node) =>
          node?.data?.checkLogNum ===
            suspendedCheckTabData?.rowSelectedInRedux?.checkLogNum &&
          node?.setSelected(true)
      );
    } else {
      params.api.forEachNode(
        (node) => node?.rowIndex === 0 && node?.setSelected(true)
      );
    }
  };
  // handing by default first row selection function
  const onGridReadyForInvoiceGrid = (params) => {
    if (suspendedCheckTabData?.invGridSelectRowRedux) {
      params.api.forEachNode(
        (node) =>
          node?.data?.index ===
            suspendedChecksMfgResponse?.filter((x) => {
              return (
                x.index === suspendedCheckTabData?.invGridSelectRowRedux?.index
              );
            })[0]?.index && node?.setSelected(true)
      );
    } else {
      params.api.forEachNode(
        (node) => node?.rowIndex === 0 && node?.setSelected(true)
      );
    }
    setGridParamsForInvGrid(params);
  };
  const RedColor='#a81f00';

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/suspendedCheck', true);
    } else {
      tabHighLigther('/suspendedCheck', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (linkTableName === 'CHECK_LOG' && showComments) {
      const tempObj =
        suspendedCheckLogResponse &&
        suspendedCheckLogResponse?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      setSuspendedCheckGridData([]);
      setSuspendedCheckGridData(tempObj);
      // eslint-disable-next-line no-unused-expressions
      handleRefreshCell(gridParams);
    }
    if (linkTableName === 'INVOICE_HEADER' && showComments) {
      const tempObj =
        suspendedCheckInvGirdData &&
        suspendedCheckInvGirdData?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      setSuspendedCheckInvGirdData([]);
      setSuspendedCheckInvGirdData(tempObj);
      // eslint-disable-next-line no-unused-expressions
      handleRefreshCell(gridParamsForInvGrid);
    }
  }, [commentsList]);
  // handle after call service show success and error message
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'Success') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      dispatch(getSuspendedCheckLogGrid({}));
      dispatch(handleErrorMessagesInRedux([]));
      setPermanentDeleteCheckList([]);
      setDisabledSaveCancelBtn('Yes');
      addEditSuspendedCheckTab({
        disabledSaveCancelBtn: 'Yes',
        successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
      });
      if (!clickOncloseTabBtn) {
        dispatch(postSaveOrUpdate(null));
        addEditSuspendedCheckTab({});
        dispatch(dispatchGetSuspendedCheckLogGrid([]));
        closeTab('/suspendedCheck', history, dispatch);
      }
    } else if (saveOrUpdateMessage === 'failed') {
      dispatch(
        handleErrorMessagesInRedux([
          { message: constantMessageData.FAILED_MESSAGE_GENERIC },
        ])
      );
      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn('No');
    }
  }, [saveOrUpdateMessage]);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      suspendedCheckTabData &&
      Object.keys(suspendedCheckTabData).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (
          item.navTo === '/suspendedCheck' &&
          disabledSaveCancelBtn === 'No'
        ) {
          item.isFormDirty = true;
        } else if (item.navTo === '/suspendedCheck') item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disabledSaveCancelBtn === 'No' || suspendedCheckTabData]);
  // handle save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    if (disabledSaveCancelBtn === 'No') {
      dispatch(handleErrorMessagesInRedux([]));
      setSuccessMessage([]);
      openSave(value);
    }
  };
  // click on yes button after call
  const masterDataSave = () => {
    handleSaveClose();
    handelCancelClose();
    if (permanentDeleteCheckList?.length > 0) {
      const saveRequest = permanentDeleteCheckList?.map((item) => {
        return {
          suspendedDtFlag: item.suspendedDtFlag,
          checkLogNum: item.checkLogNum,
          balanceTypeCd: item.balanceTypeCd,
          rebateProgramCd: item.rebateProgramCd ? item.rebateProgramCd : null,
          mfgId: item.mfgId ? item.mfgId : null,
          unallocatedBalanceSeqNum: item.unallocatedBalanceSeqNum,
          origCheckLogNum: item.checkLogNum,
          unallocatedBalanceAmt: parseFloat(
            item.endingBalance?.toString().replace(/\,/g, '').split('$')[1]
          ),
          lastUpdateUserId: UserDefaultValues?.userId
            ? UserDefaultValues?.userId
            : logInUser,
        };
      });
      dispatch(postSaveOrUpdate(saveRequest));
    }
  };
  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'Success') {
      dispatch(postSaveOrUpdate(null));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/suspendedCheck' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/suspendedCheck' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // reset All fields after click cancel button
  const resetAllFields = () => {
    handelCancelClose();
    setSuccessMessage([]);
    setPermanentDeleteCheckList([]);
    setDisabledSaveCancelBtn('Yes');
    dispatch(dispatchGetSuspendedCheckLogGrid([]));
    dispatch(getSuspendedCheckLogGrid({}));
    dispatch(handleErrorMessagesInRedux([]));
    addEditSuspendedCheckTab({});
    handleClearFilter();
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === '/suspendedCheck') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // call Declare Overpayment Confirmation popup
  const handleOverpaymentOpenPopup = (
    suspendedInvoiceGrid,
    suspendedCheckTabObj
  ) => {
    if (suspendedInvoiceGrid?.length > 0) {
      const checkAmt = parseFloat(
        suspendedCheckTabObj?.rowSelectedInRedux?.checkAmt
          ?.toString()
          .replace(/,/g, '')
          .split('$')[1]
          .trim()
      );
      const BeginningUnusedBal = parseFloat(
        suspendedCheckTabObj?.rowSelectedInRedux?.beginingBalance
          ?.toString()
          .replace(/,/g, '')
          .split('$')[1]
      );
      const totAllocatedAmt = parseFloat(
        suspendedCheckTabObj?.rowSelectedInRedux?.totAllocatedAmt
          ?.toString()
          .replace(/,/g, '')
          .split('$')[1]
      );
      const availableAmt = checkAmt + BeginningUnusedBal;
      if (availableAmt > totAllocatedAmt && parseFloat(availableAmt) !== 0) {
        addEditSuspendedCheckTab({
          ...suspendedCheckTabObj,
          clickActionName: 'overPayment',
        });
        handleUnallocatedBalance(suspendedCheckTabObj);
      } else {
        setWarningAlert(true);
        setWaringMessage(constantMessageData.WARNING_MSG_FOR_OVER_PAYMENT);
        setWaringTitle('Display Suspended Checks');
      }
    }
    if (!suspendedInvoiceGrid?.length > 0) {
      setWarningAlert(true);
      setWaringMessage(constantMessageData.NO_SELECTED_ROW);
      setWaringTitle('Warning');
    }
  };
  // call Declare Credit Balance Confirmation popup
  const handleCreditBalanceOpenPopup = (data, suspendedCheckTabObj) => {
    if (data?.length > 0) {
      handleCreditBalConfirm(suspendedCheckTabObj);
    }
    if (!data?.length > 0) {
      setWarningAlert(true);
      setWaringMessage(constantMessageData.NO_SELECTED_ROW);
      setWaringTitle('Warning');
    }
  };
  // handing Invoice Detail page redirect
  const handleViewDetailsForInvoiceDetail = async (
    data,
    suspendedCheckTabObj
  ) => {
    if (data?.length > 0) {
      await dispatch(
        getInvoiceDetailsByInvoiceNum({
          invoiceNum: suspendedCheckTabObj?.invGridSelectRowRedux
            ? suspendedCheckTabObj.invGridSelectRowRedux?.invoiceNum
            : suspendedCheckInvGirdData[0]?.invoiceNum,
        })
      );
      redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
    } else {
      setWarningAlert(true);
      setWaringMessage(constantMessageData.NO_FOUND_INVOICE_ROW);
    }
  };
  // click on Declare Credit Balance Confirmation popup after call API service
  const handleCreditBalConfirm = (suspendedCheckTabObj) => {
    setCreditBalanceConfirmPopup(false);
    if (suspendedCheckTabObj) {
      const selectedRow =
        suspendedCheckTabObj?.defaultSelectedRow ||
        suspendedCheckTabObj?.invGridSelectRowRedux;
      dispatch(
        getCreditBalConfirmation({
          allocatedCheckLogNum:
            suspendedCheckTabObj?.rowSelectedInRedux?.checkLogNum,
          mfgId: selectedRow?.mfgId,
        })
      );
    }
  };
  // click on full screen icon after call in Check grid
  const handleFullScreenViewForFirstGrid = () => {
    setFullScreenViewForFirstGrid(!fullScreenViewForFirstGrid);
    addEditSuspendedCheckTab({
      ...suspendedCheckTabData,
      fullScreenViewForFirstGrid: !fullScreenViewForFirstGrid,
    });
  };
  // click on full screen icon after call in invoice Grid
  const handleFullScreenViewForSecondGrid = () => {
    setFullScreenViewForSecondGrid(!fullScreenViewForSecondGrid);
    addEditSuspendedCheckTab({
      ...suspendedCheckTabData,
      fullScreenViewForSecondGrid: !fullScreenViewForSecondGrid,
    });
  };
  // click on full screen icon after call in Reconciliation Grid
  const handleFullScreenViewForThirdGrid = () => {
    setFullScreenViewForThirdGrid(!fullScreenViewForThirdGrid);
    addEditSuspendedCheckTab({
      ...suspendedCheckTabData,
      fullScreenViewForThirdGrid: !fullScreenViewForThirdGrid,
    });
  };
  // click on view history icon after call
  const handleViewHistory = (gridApi) => {
    const checkLogNum = gridApi.getSelectedRows()?.[0]?.checkLogNum;
    setShowViewHistory(true);
    setLinkTableName('CHECK_LOG');
    setKeyValue({ CHECK_LOG_NUM: checkLogNum || null });
  };
  return (
    <div data-testid='suspended_check'>
      <div className='tabs-container'>
        <div className='paneldevider-line'>
          <SaveCancelPopup
            open={open}
            data-testid='savePopup'
            title='Save'
            onConfim={() => {
              masterDataSave();
            }}
            onCancel={() => {
              handleSaveClose();
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            data-testid='cancelPopup'
            title='Cancel'
            onConfim={() => {
              resetAllFields();
            }}
            onCancel={() => {
              handelCancelClose();
            }}
          />
          <Spinner load={spinnerLoader} />
          <div className='panel'>
            {!fullScreenViewForFirstGrid &&
              !fullScreenViewForSecondGrid &&
              !fullScreenViewForThirdGrid && (
                <>
                  <CustomSeparator
                    parent1='Research'
                    parent2='Suspended Checks'
                  />
                  <DisplayErrorMessages
                    errorMessages={[
                      ...new Set(
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) => l.message)
                          : []
                      ),
                    ]}
                  />
                  <DisplaySuccessMessages successMessages={successMessages} />
                  <div className='flex-block justify-end pb-1'>
                    <div className='btn-wrapper float-right'>
                      <Button
                        className='btn btn-success btn-save'
                        data-testid='saveBtn'
                        disabled={disabledSaveCancelBtn === 'Yes'}
                        onClick={() => {
                          onSubmit(true);
                        }}
                      >
                        {' '}
                        <SVGComponent iconName='Icon-awesome-save' />
                        Save
                      </Button>

                      <Button
                        className='btn btn-cancel'
                        data-testid='cancelBtn'
                        onClick={() => handleOpenClose()}
                        disabled={disabledSaveCancelBtn === 'Yes'}
                      >
                        <SVGComponent iconName='Icon-cancel' />
                        Cancel
                      </Button>
                    </div>
                  </div>
                </>
              )}
          </div>
          {!fullScreenViewForSecondGrid && !fullScreenViewForThirdGrid && (
            <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
              <TableGrid
                ref={gridRef}
                gridCall={onGridReady}
                gridHeight={
                  fullScreenViewForFirstGrid ? '70vh' : tableGridHight350
                }
                rowData={suspendedCheckGridData}
                columnDefs={checkGridTableHead}
                fullScreenView={fullScreenViewForFirstGrid}
                handleFullScreenViewClick={handleFullScreenViewForFirstGrid}
                applyFilter={false}
                exportFile
                helpMessage=''
                data-testid='onCheckGrid'
                fileName='SC-Check Grid'
                isScrollOn
                singleClickEdit
                suppressCellFocus
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                onCellFocused={onCellFocused}
                onSelect={(e) => {
                  setOverpaymentConfirmPopup(false);
                  setCreditBalanceConfirmPopup(false);
                  fetchInvoiceGridList(e?.data);
                  handleClearFilterForInvGrid();
                  setLinkTableName('CHECK_LOG');
                  setSuccessMessage([]);
                  const selectedRow =
                    gridParamsForInvGrid?.api?.getSelectedRows();
                  addEditSuspendedCheckTab({
                    ...suspendedCheckTabData,
                    rowSelectedInRedux: e?.data,
                    successMessages: [],
                    defaultSelectedRow:
                      selectedRow?.length > 0 ? selectedRow[0] : null,
                  });
                }}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const suspendedInvoiceGrid = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.invoiceGridList;
                    });
                    const suspendedCheckTabObj = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.suspendedCheckTabObj;
                    });
                    return (
                      <div
                        className='tdCell icon-btn-group'
                        data-testid='action-column'
                      >
                        {showComments ? (
                          <Button
                            onClick={() => {
                              setCorrLinkId(cellInfo.data.corrLinkId);
                              setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                              setShowComments(true);
                              setLinkTableName('CHECK_LOG');
                            }}
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setCorrLinkId(cellInfo.data.corrLinkId);
                                setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                                setShowComments(true);
                                setLinkTableName('CHECK_LOG');
                              }
                            }}
                            aria-label='Comment'
                            className={`th-ic comment-ic ${
                              parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1
                                ? 'frr-enabled-comment-btn'
                                : 'frr-disabled-comment-btn'
                            }`}
                            variant='text'
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                              <img alt='' src={CommentVisibleIcon} />
                            ) : (
                              <img alt='' src={CommentIcon} />
                            )}
                          </Button>
                        ) : (
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='com-tooltip'>Comment</Tooltip>
                            }
                          >
                            <Button
                              onClick={() => {
                                setCorrLinkId(cellInfo.data.corrLinkId);
                                setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                                setShowComments(true);
                                setLinkTableName('CHECK_LOG');
                              }}
                              tabIndex={'0'}
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  setCorrLinkId(cellInfo.data.corrLinkId);
                                  setRowGridPrimaryKey(
                                    cellInfo.data.checkLogNum
                                  );
                                  setShowComments(true);
                                  setLinkTableName('CHECK_LOG');
                                }
                              }}
                              aria-label='Comment'
                              className={`th-ic comment-ic ${
                                parseInt(
                                  cellInfo.data.ccCommentsExist,
                                  [0, 1]
                                ) === 1
                                  ? 'frr-enabled-comment-btn'
                                  : 'frr-disabled-comment-btn'
                              }`}
                              variant='text'
                            >
                              {parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1 ? (
                                <img alt='' src={CommentVisibleIcon} />
                              ) : (
                                <img alt='' src={CommentIcon} />
                              )}
                            </Button>
                          </OverlayTrigger>
                        )}

                        <Dropdown className='icon-dropdown-container'>
                          <Dropdown.Toggle
                            className='icon-dropdown export_wrap'
                            aria-label='export'
                          >
                            <OverlayTrigger
                              placement='bottom'
                              overlay={
                                <Tooltip id='action-tooltip'>Actions</Tooltip>
                              }
                            >
                              <SVGComponent iconName='Icon-export1' />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='export_dropdown'>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                setDeletePopup(true);
                              }}
                            >
                              Remove Check Suspension
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleOverpaymentOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Overpayment
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleCreditBalanceOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Credit Balance
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              onClick={() => {
                                handleViewDetailsForInvoiceDetail(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Go to Invoice
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  CheckIssuerCellRender: (cellInfo) => {
                    const name = cellInfo.data && cellInfo.data.checkIssuer;
                    if (name && name.length > 15) {
                      return (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='labeler-tooltip'>{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                  CheckAmtCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.checkAmt?.toString().split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.checkAmt
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.checkAmt}`}</div>
                        )}
                      </>
                    );
                  },
                  BeginningBalanceCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.beginingBalance
                          ?.toString()
                          .split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.beginingBalance
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.beginingBalance}`}</div>
                        )}
                      </>
                    );
                  },
                  TotAllocatedAmtCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.totAllocatedAmt
                          ?.toString()
                          .split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.totAllocatedAmt
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.totAllocatedAmt}`}</div>
                        )}
                      </>
                    );
                  },
                  EndingBalanceCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.endingBalance?.toString().split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.endingBalance
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.endingBalance}`}</div>
                        )}
                      </>
                    );
                  },
                }}
              />
            </div>
          )}
          {!fullScreenViewForFirstGrid && !fullScreenViewForThirdGrid && (
            <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
              <TableGrid
                ref={gridRef1}
                gridCall={onGridReadyForInvoiceGrid}
                gridHeight={
                  fullScreenViewForSecondGrid ? '70vh' : tableGridHight350
                }
                rowData={suspendedCheckInvGirdData}
                columnDefs={TableHeaderForInvoiceGrid}
                fullScreenView={fullScreenViewForSecondGrid}
                handleFullScreenViewClick={handleFullScreenViewForSecondGrid}
                applyFilter={false}
                exportFile
                helpMessage=''
                data-testid='invoice-grid'
                fileName='SC-Manufacturer Invoice Grid'
                singleClickEdit
                suppressCellFocus
                isScrollOn
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                onCellFocused={onCellFocused}
                onSelect={(e) => {
                  fetchReconciliationGridList(e?.data);
                  setLinkTableName('INVOICE_HEADER');
                  setSuccessMessage([]);
                  addEditSuspendedCheckTab({
                    ...suspendedCheckTabData,
                    defaultSelectedRow: [],
                    successMessages: [],
                  });
                  addEditSuspendedCheckTab({
                    ...suspendedCheckTabData,
                    invGridSelectRowRedux: e?.data,
                    defaultSelectedRow: e?.api?.getSelectedRows()[0],
                  });
                }}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const suspendedInvoiceGrid = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.invoiceGridList;
                    });
                    const suspendedCheckTabObj = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.suspendedCheckTabObj;
                    });
                    return (
                      <div
                        className='tdCell icon-btn-group'
                        data-testid='action-column'
                      >
                        {showComments ? (
                          <Button
                            onClick={() => {
                              setCorrLinkId(cellInfo.data?.corrLinkId);
                              setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                              setShowComments(true);
                              setLinkTableName('INVOICE_HEADER');
                            }}
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setCorrLinkId(cellInfo.data?.corrLinkId);
                                setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                                setShowComments(true);
                                setLinkTableName('INVOICE_HEADER');
                              }
                            }}
                            className={`th-ic comment-ic ${
                              parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1
                                ? 'frr-enabled-comment-btn'
                                : 'frr-disabled-comment-btn'
                            }`}
                            variant='text'
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                              <img alt='comment' src={CommentVisibleIcon} />
                            ) : (
                              <img alt='comment' src={CommentIcon} />
                            )}
                          </Button>
                        ) : (
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='com-tooltip'>Comment</Tooltip>
                            }
                          >
                            <Button
                              onClick={() => {
                                setCorrLinkId(cellInfo.data?.corrLinkId);
                                setRowGridPrimaryKey(cellInfo.data.checkLogNum);
                                setShowComments(true);
                                setLinkTableName('INVOICE_HEADER');
                              }}
                              tabIndex={'0'}
                              onKeyDown={(e) => {
                                // Handle Enter and Space key events
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault(); // Prevents the default space scrolling behavior
                                  setCorrLinkId(cellInfo.data?.corrLinkId);
                                  setRowGridPrimaryKey(
                                    cellInfo.data.checkLogNum
                                  );
                                  setShowComments(true);
                                  setLinkTableName('INVOICE_HEADER');
                                }
                              }}
                              className={`th-ic comment-ic ${
                                parseInt(
                                  cellInfo.data.ccCommentsExist,
                                  [0, 1]
                                ) === 1
                                  ? 'frr-enabled-comment-btn'
                                  : 'frr-disabled-comment-btn'
                              }`}
                              variant='text'
                            >
                              {parseInt(
                                cellInfo.data.ccCommentsExist,
                                [0, 1]
                              ) === 1 ? (
                                <img alt='comment' src={CommentVisibleIcon} />
                              ) : (
                                <img alt='comment' src={CommentIcon} />
                              )}
                            </Button>
                          </OverlayTrigger>
                        )}

                        <Dropdown className='icon-dropdown-container'>
                          <Dropdown.Toggle
                            className='icon-dropdown export_wrap'
                            aria-label='export'
                          >
                            <OverlayTrigger
                              placement='bottom'
                              overlay={
                                <Tooltip id='action-tooltip'>Actions</Tooltip>
                              }
                            >
                              <SVGComponent iconName='Icon-export1' />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='export_dropdown'>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleOverpaymentOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Overpayment
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleCreditBalanceOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Credit Balance
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              onClick={() => {
                                handleViewDetailsForInvoiceDetail(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Go to Invoice
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  nameRenderMFG: (cellInfo) => {
                    const name = cellInfo?.data?.mfgName;
                    if (name && name.length > 22) {
                      return (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='labeler-tooltip'>{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                  TotInvoiceAmtCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.totInvoiceAmt?.toString().split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.totInvoiceAmt
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.totInvoiceAmt}`}</div>
                        )}
                      </>
                    );
                  },
                }}
              />
            </div>
          )}
          {!fullScreenViewForFirstGrid && !fullScreenViewForSecondGrid && (
            <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
              <TableGrid
                gridHeight={
                  fullScreenViewForThirdGrid ? '70vh' : tableGridHight350
                }
                rowData={suspendedChecksInvoiceResponseVO}
                columnDefs={TableHeaderForQuarter}
                fullScreenView={fullScreenViewForThirdGrid}
                handleFullScreenViewClick={handleFullScreenViewForThirdGrid}
                applyFilter={false}
                exportFile
                helpMessage=''
                data-testid='Reconciliation-grid'
                fileName='SC-Check Reconciliation Grid'
                hideColumnsInPdf={['action']}
                singleClickEdit
                suppressCellFocus
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                onCellFocused={onCellFocused}
                onSelect={() => {
                  setSuccessMessage([]);
                  addEditSuspendedCheckTab({
                    ...suspendedCheckTabData,
                    successMessages: [],
                    defaultSelectedRow:
                      gridParamsForInvGrid?.api?.getSelectedRows()[0],
                  });
                }}
                frameworkComponents={{
                  ActionCellRender: () => {
                    const suspendedInvoiceGrid = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.invoiceGridList;
                    });
                    const suspendedCheckTabObj = useSelector((state) => {
                      return state.sharedState.SuspendedCheckReducer
                        ?.suspendedCheckTabObj;
                    });
                    return (
                      <div
                        className='tdCell icon-btn-group'
                        data-testid='action-column'
                      >
                        <Dropdown className='icon-dropdown-container'>
                          <Dropdown.Toggle
                            className='icon-dropdown export_wrap'
                            aria-label='export'
                          >
                            <OverlayTrigger
                              placement='bottom'
                              overlay={
                                <Tooltip id='action-tooltip'>Actions</Tooltip>
                              }
                            >
                              <SVGComponent iconName='Icon-export1' />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='export_dropdown'>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleOverpaymentOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Overpayment
                            </Dropdown.Item>
                            <Dropdown.Item
                              role='button'
                              disabled={isReadOnly}
                              onClick={() => {
                                handleCreditBalanceOpenPopup(
                                  suspendedInvoiceGrid,
                                  suspendedCheckTabObj
                                );
                              }}
                            >
                              Declare Credit Balance
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  interestPaidAmtRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.interestPaidAmt
                          ?.toString()
                          .split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.interestPaidAmt
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.interestPaidAmt}`}</div>
                        )}
                      </>
                    );
                  },
                  principalPaidAmtRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(
                        cellInfo?.data?.principalPaidAmt
                          ?.toString()
                          .split('$')[1]
                      ) >= 0
                    );
                    return (
                      <>
                        {isNegativeVal ? (
                          <div
                            style={{ color: RedColor }}
                          >{`(${cellInfo?.data?.principalPaidAmt
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.principalPaidAmt}`}</div>
                        )}
                      </>
                    );
                  },
                }}
              />
            </div>
          )}
        </div>
        {!fullScreenViewForFirstGrid &&
          !fullScreenViewForSecondGrid &&
          !fullScreenViewForThirdGrid && (
            <div className='flex-block justify-end pb-1'>
              <div className='btn-wrapper float-right'>
                <Button
                  className='btn btn-success btn-save'
                  data-testid='saveBtn1'
                  disabled={disabledSaveCancelBtn === 'Yes' || isReadOnly}
                  onClick={() => {
                    onSubmit(true);
                  }}
                >
                  {' '}
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
                <Button
                  className='btn btn-cancel'
                  data-testid='cancelBtn1'
                  disabled={disabledSaveCancelBtn === 'Yes' || isReadOnly}
                  onClick={() => handleOpenClose()}
                >
                  <SVGComponent iconName='Icon-cancel' />
                  Cancel
                </Button>
              </div>
            </div>
          )}
      </div>
      <CommonModal
        open={deletePopup}
        className='dialogPanel custom-check dialog-420'
        data-testid='commonModalForRemoveCheck'
        viewAction
        viewHeader
        modalTitle='Suspended Check'
        okTitle='Yes'
        closeTitle='No'
        removeClassName
        childrenComponent={
          <>Are you certain you want to remove the suspension for this check?</>
        }
        onOk={() =>
          handleRemoveCheckSuspension(
            suspendedCheckTabData?.rowSelectedInRedux,
            true
          )
        }
        onClose={() => setDeletePopup(false)}
      />
      <CommonModal
        open={overpaymentConfirmPopup}
        className='dialogPanel custom-check dialog-420'
        data-testid='common-modal-overpayment'
        viewAction
        viewHeader
        modalTitle='Overpayment Confirmation'
        okTitle='Ok'
        closeTitle='Cancel'
        removeClassName
        childrenComponent={
          <>
            <div>
              An overpayment for the following Manufacturer and amount will be
              created for future allocation when OK is selected.
            </div>
            <div className='mt-3 input-md'>
              <TextField
                id='mfgId'
                label='Manufacturer ID'
                disabled
                placeholder=''
                InputLabelProps={{ shrink: true }}
                value={
                  suspendedCheckTabData.defaultSelectedRow
                    ? suspendedCheckTabData.defaultSelectedRow?.mfgId
                    : suspendedChecksMfgResponse[0]?.mfgId
                }
              />
            </div>
            <div className='mt-3 input-md'>
              <TextField
                id='invoiceNumber'
                label='Overpayment Amount'
                disabled
                placeholder=''
                InputLabelProps={{ shrink: true }}
                value={`$ ${
                  parseFloat(
                    suspendedCheckTabData?.rowSelectedInRedux?.endingBalance
                      ?.toString()
                      ?.replace(/\,/g, '')
                      .split('$')[1]
                      .trim()
                  ) +
                  (unallocatedBalance?.unallocatedBalance > 0
                    ? parseFloat(unallocatedBalance?.unallocatedBalance)
                    : 0)
                }`}
              />
            </div>
          </>
        }
        onOk={() => {
          setOverpaymentConfirmPopup(false);
          handleRemoveCheckSuspension(
            suspendedCheckTabData?.rowSelectedInRedux,
            false,
            'OPMT'
          );
        }}
        onClose={() => setOverpaymentConfirmPopup(false)}
      />
      <CommonModal
        open={creditBalanceConfirmPopup}
        className='dialogPanel custom-check dialog-420'
        data-testid='common-modal-credit-bal'
        viewAction
        viewHeader
        modalTitle='Declare Credit Balance Confirmation'
        okTitle='Ok'
        closeTitle='Cancel'
        removeClassName
        childrenComponent={
          <>
            <div>
              A credit balance for the following Manufacturer and amount will be
              created for future allocation when OK is selected.{' '}
            </div>
            <div className='mt-3 input-md'>
              <TextField
                id='mfgId'
                label='Manufacturer ID'
                disabled
                placeholder=''
                InputLabelProps={{ shrink: true }}
                value={
                  suspendedCheckTabData.defaultSelectedRow
                    ? suspendedCheckTabData.defaultSelectedRow?.mfgId
                    : suspendedChecksMfgResponse[0]?.mfgId
                }
              />
            </div>
            <div className='mt-3 input-md'>
              <TextField
                id='invoiceNumber'
                label='Credit Balance Amount'
                disabled
                placeholder=''
                InputLabelProps={{ shrink: true }}
                value={`$ ${
                  parseFloat(
                    suspendedCheckTabData?.rowSelectedInRedux?.totAllocatedAmt
                      ?.toString()
                      .split('$')[1]
                      .trim()
                  ) +
                  (unallocatedBalance?.unallocatedBalance > 0
                    ? parseFloat(unallocatedBalance?.unallocatedBalance)
                    : 0)
                }`}
              />
            </div>
          </>
        }
        onOk={() => {
          setCreditBalanceConfirmPopup(false);
          handleRemoveCheckSuspension(
            suspendedCheckTabData?.rowSelectedInRedux,
            false,
            'LCB'
          );
        }}
        onClose={() => setCreditBalanceConfirmPopup(false)}
      />
      <CommonModal
        className='dialog-420'
        data-testid='common-modal-warning'
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => setWarningAlert(false)}
        onClose={() => setWarningAlert(false)}
        okTitle='Ok'
        modalTitle={warningTitle}
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={linkTableName}
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={rowGridPrimaryKey && rowGridPrimaryKey.toString()}
        />
      ) : null}
    </div>
  );
}
export default SuspendedCheckComponent;
